import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { css } from "styled-components";

/**
 * Shared field wrapper. No horizontal inset — Contact Us fields sit flush in the
 * form GridItem; Dynamic Form matches that so labels/inputs share one left edge.
 */
const styles: InjectableCss = {
    css: css`
        width: 100%;
        max-width: 100%;
        box-sizing: border-box;
        display: block;
    `,
};

/** Shared wrapper so field widgets align with reCAPTCHA and Submit like Contact Us. */
const DynamicFormFieldShell: React.FC<{ children?: React.ReactNode }> = ({ children }) => (
    <StyledWrapper {...styles}>{children}</StyledWrapper>
);

export default DynamicFormFieldShell;
